import { render, staticRenderFns } from "./CardEnvioDeEmail.vue?vue&type=template&id=35962d54&"
import script from "./CardEnvioDeEmail.vue?vue&type=script&lang=js&"
export * from "./CardEnvioDeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports